import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import AuthDemo from "./AuthDemo";
import { usePublicTestimonials } from "../Testimonials";
import { usePricing, dkk } from "../../lib/pricing";

function Brand() {
  return (
    <Link to="/" className="as-brand" data-testid="auth-brand-link">
      <img src="/logo.svg?v=2" alt="" width="34" height="34" />
      <span>JaTak Pro</span>
    </Link>
  );
}

const FEATURES = ['Facebook-robot der svarer på "ja tak"', "Varianter og venteliste", "Udlevering med QR-scanning", "SMS-påmindelser", "Statistik og app på telefonen"];
const STEPS = ["Opret butik", "Forbind jeres Facebook-side", "Læg første tilbud op"];

function Quote({ q }) {
  return q ? (
    <figure className="as-quote" data-testid="auth-testimonial">
      <blockquote>"{q.quote}"</blockquote>
      <figcaption>{q.person_name} · {q.shop_name}</figcaption>
    </figure>
  ) : null;
}

function SignupPanel({ p, q }) {
  return (
    <aside className="as-panel su" data-testid="signup-panel">
      <Brand />
      <h2 className="su-h">Kom i gang på 5 minutter</h2>
      <div className="su-price" data-testid="signup-price-card">
        <div className="su-amount">
          <span className="su-num" data-testid="signup-price-value">{dkk(p.price_monthly_dkk)}</span>
          <span className="su-unit">kr./md.</span>
          <span className="su-ex">ekskl. moms</span>
        </div>
        <p className="su-incl" data-testid="signup-price-incl">{dkk(p.price_monthly_incl_vat)} kr. inkl. moms</p>
        <ul className="su-chips">
          <li data-testid="signup-chip-trial">{p.trial_days} dage gratis</li><li>Intet kort</li><li>Ingen binding</li><li>0 kr. gebyr pr. salg</li>
        </ul>
        <Link to="/priser" className="su-more" data-testid="signup-panel-pricing-link">Se alt, der er med →</Link>
      </div>
      <div className="su-cols">
        <section>
          <h3>Det får I</h3>
          <ul className="su-list">{FEATURES.map((f) => <li key={f}><Check size={14} /> {f}</li>)}</ul>
        </section>
        <section>
          <h3>Sådan kommer I i gang</h3>
          <ol className="su-steps">{STEPS.map((s, i) => <li key={s}><span>{i + 1}</span> {s}</li>)}</ol>
        </section>
      </div>
      <Quote q={q} />
    </aside>
  );
}

export default function AuthShell({ children, variant = "login" }) {
  const quotes = usePublicTestimonials();
  const p = usePricing();
  const { trial_days } = p;
  const q = quotes[0];
  const signup = variant === "signup";
  return (
    <div className="as" data-testid="auth-shell">
      {signup ? <SignupPanel p={p} q={q} /> : <aside className="as-panel">
        <Brand />
        <div className="as-copy">
          <h2>Sælg mere på Facebook – uden at løfte en finger</h2>
          <ul>
            <li><Check size={16} /> Robotten svarer på sekunder</li>
            <li><Check size={16} /> Ingen gebyr pr. salg</li>
            <li><Check size={16} /> {trial_days} dages gratis prøve</li>
          </ul>
        </div>
        <AuthDemo />
        <Quote q={q} />
      </aside>}
      <header className="as-mhead">
        <Brand />
        {signup ? (
          <p className="su-mline" data-testid="signup-mobile-price">
            {dkk(p.price_monthly_dkk)} kr./md. ekskl. moms · {trial_days} dage gratis · ingen binding · <Link to="/priser">Se priser</Link>
          </p>
        ) : <p>Sælg mere på Facebook – uden at løfte en finger</p>}
      </header>
      <main className="as-main">
        <div className="as-card">{children}</div>
        <p className="as-foot"><Link to="/priser" data-testid="auth-pricing-link">Se priser</Link> · <Link to="/privatliv" data-testid="auth-privacy-link">Privatliv</Link> · <Link to="/vilkaar" data-testid="auth-terms-link">Vilkår</Link></p>
      </main>
    </div>
  );
}
